module.exports = __webpack_public_path__ + "static/media/26.cab23a0f.png";